export const staffType = [
  { label: 'RPN', value: 'RPN' },
  { label: 'RN', value: 'RN' },
  { label: 'Lab Technician', value: 'Lab Technician' },
  { label: 'Receptionist', value: 'Receptionist' },
];
